import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Services.css";

const services = [
  {
    title: "Block Chain",
    description:
      "Unlock the potential of blockchain technology with Renesis. From secure smart contracts to decentralized apps, we design robust systems that enhance transparency, security, and efficiency.",
    image: './assets/blockChain.png',
  },
  {
    title: "Mobile Development",
    description:
      "Successful mobile applications start with a winning mobile . Renesis gives you the talent required to quickly create monetizable apps that engage and entertain your users.",
    image: './assets/appDev.png',
  },
  {
    title: "AI Application",
    description:
      "Our team develops advanced AI applications to revolutionize your business. From intelligent predictive analytics to natural language processing and computer vision, we create scalable, efficient solutions that streamline operations, enhance decision-making, and accelerate growth with cutting-edge AI technology.",
    image: './assets/ai.webp',
    fullWidth: true,
  },
  {
    title: "Web Development",
    description:
      "At Renesis, we craft exceptional web solutions that blend creativity, functionality, and performance. From sleek designs to robust development, we build websites that elevate your online presence.",
    image: './assets/webLanding.png',
  },
  {
    title: "Custom Applications",
    description:
      "Renesis specializes in creating custom applications tailored to your unique needs. From concept to deployment, we build powerful, scalable solutions that enhance productivity and drive business growth.",
    image: './assets/appDevp.png',
  },
];

const Services = () => {
  const navigate = useNavigate();

  const handleViewWork = (serviceTitle) => {
    // Navigate to service details page
    navigate('/serviceDetails');
  };

  return (
    <section className="services-section">
      <Container>
        <Row className="g-4">
          {services.map((service, index) => (
            <Col xs={12} md={service.fullWidth ? 12 : 6} key={index}>
              <Card className={`service-card bg-light d-flex flex-column flex-md-row align-items-start justify-content-between ${service.fullWidth ? 'full-width' : ''}`}>
                <Card.Body className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description-m">{service.description}</p>
                  <button 
                    className="view-work" 
                    onClick={() => handleViewWork(service.title)}
                  >
                    View Work →
                  </button>
                </Card.Body>
                <div className="service-image">
                  <img src={service.image} alt={service.title} className="service-img full-height-width" />
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Services;
